const stripTags = text => (text ? text.trim().replace(/<[^>]*>?/gm, '') : text);

export default stripTags;
